module.exports = __webpack_public_path__ + "img/legian-bali_0.4935771d.jpg";